import {
  Box,
  Typography,
  Grid,
  Chip,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const HomophonesSection = ({ homophones }) => {
  const theme = useTheme();

  if (!homophones || homophones.length === 0) return null;

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle2" color="primary" gutterBottom>
        Similar sounding words
      </Typography>
      <Box sx={{ 
        p: 2,
        bgcolor: alpha(theme.palette.background.paper, 0.4),
        borderRadius: 1,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1
      }}>
        {homophones.map((homophone, index) => (
          <Chip
            key={index}
            label={homophone}
            variant="outlined"
            sx={{
              bgcolor: alpha(theme.palette.info.main, 0.05),
              color: theme.palette.info.main,
              borderColor: alpha(theme.palette.info.main, 0.3)
            }}
          />
        ))}
      </Box>
    </Grid>
  );
};

export default HomophonesSection;